<template>
  <div class="main-page legalaid">
    <Menus
      title="办证指引"
      :home="true"
    />
    <div class="container-flex">
      <div class="content-step">
        <Collect />
      </div>
    </div>
  </div>
</template>
<script>
import Menus from '@/components/Menu'
import Collect from '@/components/DataCollect/Collect'
import { NOTARY_GUIDE } from '../../datas/constants/statistics.js'
export default {
  components: {
    Menus,
    Collect
  },
  mounted () {
    this.$root.getStatistics(NOTARY_GUIDE)
  }
}
</script>
